export default "__VITE_ASSET__D6m30uTK__"